import { get, debounce } from 'lodash';
import template from './text-chat.html';
import { determineReceiverLocatedStatus } from '../../../modules/core/helpers/tracking-helpers';

const TYPING_EVENT_DELAY = 1500;

export default angular
  .module('doxy.common.components.message-chat', [])
  .component('textChat', {
    // text-chat
    template,
    bindings: {
      textChatRealtimeComponent: '<',
    },
    controller: function (
      trackingFactory,
      notificationFactory,
      globalUi,
      VideoProviderFactory,
      roomHelpersFactory,
      pn,
      $ngRedux,
      $timeout
    ) {
      this.$onInit = () => {
        // Initialize after bindings are available
        if (this.textChatRealtimeComponent && this.textChatRealtimeComponent.initHistory) {
          this.textChatRealtimeComponent.initHistory();
        }
      };

      this.ui = globalUi.ui;

      this.clearTextarea = () => (this.newMessage = null);
      this.sendMessage = function () {
        if (!Boolean(this.newMessage)) {
          return;
        }
        if (this.newMessage.length > 5000) {
          notificationFactory.showCommon(
            'error',
            `Your message has
          ${this.newMessage.length} characters. The limit is 5.000`
          );
          return;
        }
        const targetPatientUUID = this.textChatRealtimeComponent.target.uuid;
        const receiverLocatedStatus = determineReceiverLocatedStatus(
          targetPatientUUID,
          $ngRedux.getState()
        );
        const trackingProps = {
          room_id: get(roomHelpersFactory.getRoom(), 'id'),
          session_id: get(
            VideoProviderFactory,
            'activeProvider.callSession.id'
          ),
          receiver_located: receiverLocatedStatus,
        };
        if (pn.isPatient()) {
          trackingProps.user_type = 'patient';
        }
        trackingFactory.global.track('Live Chat Message Sent', trackingProps);

        this.textChatRealtimeComponent.sendMessage(
          {
            text: this.newMessage,
          },
          this.textChatRealtimeComponent.target
        );
        delete this.newMessage;
      };

      this.debouncedStopTyping = debounce(() => {
        if (this.textChatRealtimeComponent && this.textChatRealtimeComponent.sendIsTyping) {
          this.textChatRealtimeComponent.sendIsTyping(false);
        }
        this.isTyping = false;
      }, TYPING_EVENT_DELAY);

      this.onTyping = () => {
        // Do nothing if user is patient or when target patient is not in v2
        if (
          Boolean(pn.isPatient()) ||
          !Boolean(
            Boolean(this.textChatRealtimeComponent.target) &&
              this.textChatRealtimeComponent.target.isV2()
          )
        ) {
          return;
        }

        if (!Boolean(this.isTyping)) {
          if (this.textChatRealtimeComponent && this.textChatRealtimeComponent.sendIsTyping) {
            this.textChatRealtimeComponent.sendIsTyping(true);
          }
          this.isTyping = true;
        }

        this.debouncedStopTyping();
      };

      if (this.textChatRealtimeComponent && this.textChatRealtimeComponent.setCallbackOnLeave) {
        this.textChatRealtimeComponent.setCallbackOnLeave(this.clearTextarea);
      }

      this.closeChat = () => {
        if (this.textChatRealtimeComponent.pn.isPatient()) {
          this.textChatRealtimeComponent.updateTarget(null);
          $timeout(() => {
            this.textChatRealtimeComponent.updateTarget(
              VideoProviderFactory.activeProvider.peopleCollection.getDoctors()[0]
            );
            this.textChatRealtimeComponent.toggleChat(false);
          });
          return;
        }

        const patientsOnCall =
          VideoProviderFactory.activeProvider.peopleCollection.getPatients();

        const nextChatTarget =
          VideoProviderFactory.activeProvider.isInCall &&
          !VideoProviderFactory.activeProvider.isInGroupCall &&
          !this.textChatRealtimeComponent.minimized &&
          patientsOnCall[0].uuid !== this.textChatRealtimeComponent.target.uuid
            ? patientsOnCall[0]
            : null;

        this.textChatRealtimeComponent.updateTarget(null);
        if (nextChatTarget) {
          $timeout(() => {
            this.textChatRealtimeComponent.openChat(nextChatTarget, false);
          });
        }
      };

      this.showCloseButton = () => {
        const isInChatWithAnotherProvider =
          this.textChatRealtimeComponent.pn.isPatient() &&
          VideoProviderFactory.activeProvider.isInCall &&
          this.textChatRealtimeComponent.target &&
          this.textChatRealtimeComponent.target.uuid !==
            VideoProviderFactory.activeProvider.peopleCollection.getDoctors()[0]
              .uuid;

        return (
          this.textChatRealtimeComponent.pn.isDoctor() ||
          isInChatWithAnotherProvider
        );
      };
    },
  }).name;
